export const landing = '/'
export const NOT_FOUND = "/not-found"